'use client'

// src/utils/path.ts
var removeBaseUrl = (path, baseUrl) => {
  const added = path.replace(baseUrl ? baseUrl : "", "");
  const valid = added.startsWith("/") ? added : `/${added}`;
  return valid;
};
var addBaseUrl = (path, baseUrl) => {
  const removed = `${baseUrl ? baseUrl : ""}${path}`;
  const valid = removed.startsWith("/") ? removed : `/${removed}`;
  return valid;
};

export {
  removeBaseUrl,
  addBaseUrl
};
//# sourceMappingURL=chunk-HHM5XRXW.mjs.map